import { ISubscriptionsState } from '../state';

export const show_view_only_modal_factory = (state: ISubscriptionsState) => () => {
    state.showing_view_only_modal.value = true;
};
